import { Text } from "@/components/Text"
import { ProgressCircle } from "@tremor/react"

type EditDescriptionProps = {
  descriptionIsWithinMaxLength: boolean
  description: string
  changeDescription: (description: string) => void
}

const EditDescription = ({
  descriptionIsWithinMaxLength,
  description,
  changeDescription,
}: EditDescriptionProps) => {
  const percentOfMaxDescriptionLength = Math.round(
    (description.length / 128) * 100
  )

  const descriptionCharactersRemaining = 128 - description.length
  return (
    <div className="w-full flex flex-col items-start justify-center">
      <div className="w-full flex items-center justify-between">
        <label className="text-zinc-200 text-left text-sm mb-2" htmlFor="bio">
          Bio
        </label>
        {!descriptionIsWithinMaxLength && (
          <p className="text-red-500 text-sm">128 characters max</p>
        )}
      </div>
      <textarea
        className={`p-4 w-full text-white bg-zinc-900 text-lg outline-none border-2 border-zinc-700 focus:border-zinc-400 ${
          !descriptionIsWithinMaxLength && "!border-red-500"
        } transition rounded-xl shadow-md mb-2`}
        id="bio"
        defaultValue={description}
        name="description"
        placeholder="Your bio"
        onChange={(e) => changeDescription(e.target.value)}
      />
      <div className="w-full flex items-center justify-end gap-2">
        <Text>{descriptionCharactersRemaining} remaining</Text>
        <ProgressCircle
          value={percentOfMaxDescriptionLength}
          radius={10}
          strokeWidth={4}
          color={descriptionIsWithinMaxLength ? "pink" : "red"}
        />
      </div>
    </div>
  )
}

export default EditDescription
